
import { createAsyncActionCreator, IAsyncActionCreator } from '../store/actions/createActionCreator';
import { selectedItemsFacet, currentSelectionFacet } from '../facets/ScopeFacets';
import { IItemCacheThunkAction, IItemCacheDispatch } from '../store/actions/ItemCacheActions';
import { pack } from '../models/Facet';
import { ArrayMirrorPatch } from '../utilities/Graft';
import { resolveItems } from './getItems';

/**
 * @public
 */
export interface ISelectItemsPayload {
  itemsScopeItemKey: string;
  selectedItemKeys: string[];
  currentSelectionKey: string | undefined;
}

export const selectItems: IAsyncActionCreator<ISelectItemsPayload, IItemCacheThunkAction<void>> = createAsyncActionCreator((
  payload: ISelectItemsPayload
): IItemCacheThunkAction<void> => {
  const {
    itemsScopeItemKey,
    selectedItemKeys,
    currentSelectionKey
  } = payload;

  return (dispatch: IItemCacheDispatch) => {
    dispatch(resolveItems({
      items: {
        [itemsScopeItemKey]: {
          ...pack({
            selectedItems: selectedItemsFacet
          }, {
              selectedItems: {
                itemKeys: new ArrayMirrorPatch(selectedItemKeys)
              }
            }),
          ...currentSelectionKey ? currentSelectionFacet.pack({
            selectionKey: currentSelectionKey
          }) : {}
        }
      }
    }));
  };
});
